import React from 'react';

const Join = () => {
  return (
    <div className="page">
      <div className="container">
        <h1>Join as Partner</h1>
        <p>Partner with us to transform your restaurant's digital presence.</p>
      </div>
    </div>
  );
};

export default Join;
